import React, { useState } from "react";
import { Link } from "react-router-dom";

export const EnterpriseNavbar = ({ lang, toggleLanguage, navItems, actions }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isArabic = lang === "AR";

  const handleMenuClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="sticky top-0 z-50 border-b border-emerald-100 bg-white/95 backdrop-blur">
      <div className="mx-auto flex max-w-7xl 3xl:max-w-[1600px] 4k:max-w-[2000px] items-center justify-between gap-3 px-4 py-3 md:px-6 3xl:px-10 4k:px-16">
        <div className={`flex items-center gap-4 ${isArabic ? "flex-row-reverse" : ""}`}>
          <button
            type="button"
            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 text-slate-700 md:hidden"
            onClick={() => setIsMenuOpen((open) => !open)}
            aria-label={isArabic ? "فتح القائمة" : "Open navigation"}
          >
            <svg
              className="h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16m-7 6h7"
              />
            </svg>
          </button>

          <Link
            to="/"
            className={`flex items-center gap-3 no-underline ${isArabic ? "flex-row-reverse text-right" : ""}`}
          >
            <img
              src="/img/Light/logo.png"
              alt="FarmTopia logo"
              className="h-14 w-14 object-contain"
            />
            <div>
              <p className="mb-0 text-[11px] font-semibold uppercase tracking-[0.22em] text-emerald-600">
                {isArabic ? "بيت التطوير الزراعي" : "Agricultural Development House"}
              </p>
              <p className="mb-0 text-lg font-semibold text-slate-900">Farmtopia</p>
            </div>
          </Link>
        </div>

        <div className={`hidden items-center gap-6 md:!flex ${isArabic ? "flex-row-reverse" : ""}`}>
          {navItems.map((item) => (
            <a
              key={item.url}
              href={item.url}
              className="text-sm font-medium text-slate-700 no-underline transition hover:text-emerald-700"
            >
              {item.label}
            </a>
          ))}
        </div>

        <div className={`hidden items-center gap-3 md:!flex ${isArabic ? "flex-row-reverse" : ""}`}>
          <button
            type="button"
            className="rounded-full border border-slate-200 px-3 py-2 text-sm font-semibold text-slate-700"
            onClick={toggleLanguage}
          >
            {lang}
          </button>
          <Link
            to="/platform"
            className="rounded-full border border-emerald-200 px-4 py-2 text-sm font-semibold text-emerald-700 no-underline transition hover:border-emerald-300 hover:text-emerald-800"
          >
            {actions.secondary}
          </Link>
          <a
            href="#inquiry"
            className="rounded-full bg-emerald-600 px-4 py-2 text-sm font-semibold text-white no-underline transition hover:bg-emerald-700"
          >
            {actions.primary}
          </a>
        </div>

        <div className={`flex items-center gap-2 md:hidden ${isArabic ? "flex-row-reverse" : ""}`}>
          <button
            type="button"
            className="rounded-full border border-slate-200 px-3 py-2 text-xs font-semibold text-slate-700"
            onClick={toggleLanguage}
          >
            {lang}
          </button>
          <a
            href="#inquiry"
            className="rounded-full bg-emerald-600 px-3 py-2 text-xs font-semibold text-white no-underline"
          >
            {actions.primary}
          </a>
        </div>
      </div>

      {isMenuOpen ? (
        <div className="border-t border-emerald-100 bg-white md:hidden">
          <div className="space-y-2 px-4 py-4">
            {navItems.map((item) => (
              <a
                key={item.url}
                href={item.url}
                className="block rounded-2xl border border-slate-100 px-4 py-3 text-sm font-medium text-slate-700 no-underline"
                onClick={handleMenuClick}
              >
                {item.label}
              </a>
            ))}
            <Link
              to="/platform"
              className="block rounded-2xl border border-emerald-200 px-4 py-3 text-sm font-semibold text-emerald-700 no-underline"
              onClick={handleMenuClick}
            >
              {actions.secondary}
            </Link>
          </div>
        </div>
      ) : null}
    </nav>
  );
};

export default EnterpriseNavbar;
